import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { currentSsoSelector } from '../../shared/store/selectors';
import { isEditable, isGroupOwner } from './utils';

class CustomGroupAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      ownerSso: PropTypes.string,
      allowEditFlag: PropTypes.bool,
      publicFlag: PropTypes.bool,
      archivalFlag: PropTypes.bool,
    }).isRequired,
    sso: PropTypes.string.isRequired,
    addingNewGroup: PropTypes.bool,
    placeholderForNewGroup: PropTypes.string,
    enterEditMode: PropTypes.func.isRequired,
    showDeleteCustomGroupModal: PropTypes.func.isRequired,
  };

  onClickEdit = () => {
    const { enterEditMode, value } = this.props;
    return enterEditMode(value.id);
  };

  onClickDelete = () => {
    const { showDeleteCustomGroupModal, value } = this.props;
    return showDeleteCustomGroupModal({
      customGroupId: value.id,
      customGroupName: value.name,
    });
  };

  render() {
    const {
      value,
      addingNewGroup,
      sso,
      placeholderForNewGroup,
    } = this.props;

    const editable = isEditable(sso, value);
    const isOwner = isGroupOwner(sso, value);

    if (addingNewGroup && !value.id) {
      return <div>{placeholderForNewGroup}</div>;
    }

    return editable && (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Custom Group"
          onClick={this.onClickEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Custom Group"
          disabled={!isOwner}
          onClick={this.onClickDelete}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sso: currentSsoSelector(state),
});

export default connect(mapStateToProps)(CustomGroupAdminColumnRenderer);
